import moment from 'moment';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';

const initials = (name) =>
  name
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0].toUpperCase())
    .join('');

// Who filed an item and when, as a small avatar line.
const Creator = ({ item }) => {
  const name = item.createdByName || item.createdBy || 'Unknown';
  return (
    <div className="flex min-w-0 items-center gap-2 text-xs text-muted-foreground">
      <Avatar className="h-6 w-6">
        <AvatarFallback className="text-[10px] font-medium">{initials(name)}</AvatarFallback>
      </Avatar>
      <span className="truncate font-medium text-foreground">{name}</span>
      {item.createdAt && (
        <span className="whitespace-nowrap" title={moment(item.createdAt).format('MMM Do, YYYY h:mm a')}>
          · {moment(item.createdAt).fromNow()}
        </span>
      )}
    </div>
  );
};

export default Creator;
